import { z } from 'zod';

export enum TokenTypeKey {
  Quote = 'quote',
  CAD = 'cad',
}

export type TokenType = {
  key: TokenTypeKey;
  name: string;
  description: string;
};

export class TokenTypes {
  static readonly QUOTE: TokenType = {
    key: TokenTypeKey.Quote,
    name: 'Quote',
    description: 'Quote token',
  };
  static readonly CAD: TokenType = {
    key: TokenTypeKey.CAD,
    name: 'CAD',
    description: 'CAD token',
  };
}

export const TokenSettingSchema = z.object({
  id: z.number(),
  token_type: z.enum(TokenTypeKey),
  enabled: z.boolean(),
  monthly_allocation: z.number(),
  on_demand_price_per_token: z.string(),
});

export type TokenSetting = z.infer<typeof TokenSettingSchema>;
